import { useSelector } from "react-redux";
import { getMinLength, getMaxLenth } from "../redux/selectors";
import { NumberFormatter as NF } from "../../../utils/NumberFormatter";

export function useMinMaxLengthLabel() {
  const minLen = useSelector(getMinLength);
  const maxLen = useSelector(getMaxLenth);

  const minStr = minLen !== null ? NF.getDefaultFormatter().format(minLen) : "MISSING";
  const maxStr = maxLen !== null ? NF.getDefaultFormatter().format(maxLen) : "MISSING";
  const helperLabel = `${minStr}mm - ${maxStr}mm`;
  return helperLabel;
}
